export default "__VITE_ASSET__Cy5ioUJx__"